// test1776
(1776 && 0);
